import { createNode } from '@glueapp/graph-types';

export const Minimum = createNode({
    id: 'Minimum',
    name: 'Minimum',
    description: 'Gives the minimum of the two numbers',
    aiDescription:
        'Returns the smaller of two numbers. Connect values to "Number1" and "Number2" input ports; the "Result" output port provides the minimum.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number1: {
            kind: 'number',
        },
        Number2: {
            kind: 'number',
        },
    },
    outPorts: {
        Result: {
            kind: 'number',
        },
    },
    execute: function (input) {
        return { output: { Result: Math.min(input.inPorts.Number1, input.inPorts.Number2) } };
    },
});
